// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"e22104c6c127ecc17794","966":"9f34461512943190570b"}[chunkId] + ".js";
};